'use strict';

var _ = require('lodash');
var d3 = require('d3');

var statePropsHandler = void 0;

statePropsHandler = {};

statePropsHandler.getInitialState = function () {

  var stateProps = {
    data: null,
    updateType: 'init',
    realTimeUdate: true,
    tweenTime: 250,
    configMenuActive: false,
    vertexUpdate: true,
    reportUpdate: true,
    filtersActive: false,
    validationWarnings: null
  };

  return stateProps;
};

statePropsHandler.getFilterUpdateState = function (data, props) {

  data.filters.patients = props.data.patients;
  data.filters.patientsIdMap = props.data.patientsIdMap;

  var stateProps = {
    data: data,
    updateType: props.updateType,
    tweenTime: props.tweenTime,
    updatedColumnConfig: null,
    vertexUpdate: props.vertexUpdate,
    reportUpdate: props.reportUpdate,
    filtersActive: props.filtersActive,
    validationWarnings: props.validationWarnings
  };

  return stateProps;
};

statePropsHandler.getColumnsConfigUpdateState = function (data, props) {

  var updatedColumnConfig = [];

  _.each(data.parallelPlot, function (d, i) {

    // if column not found it's exluded from list
    var column = _.find(props, function (c) {
      return c.column.id === d.column.id;
    });

    if (column) {
      if (d.active !== column.active || d.header !== column.header) {
        d.active = column.active;
        d.header = column.header;
        updatedColumnConfig.push(d);
      };
    }
  });

  data.config.columns = props;

  var stateData = {
    data: data,
    updateType: 'updateColumnConfigurations',
    updatedColumnConfig: updatedColumnConfig,
    vertexUpdate: true,
    reportUpdate: false
  };

  return stateData;
};

statePropsHandler.getCohortUpdateState = function (data, props, getCohortIndex) {

  _.each(data.config.cohortSelector.cohorts, function (d) {
    var f = _.filter(d.categories, function (id) {
      return id !== props.category.id;
    });
    d.categories = f;
  });

  if (props.type === 'update') {
    data.config.cohortSelector.cohorts[props.cohort.cohortIndex].categories.push(props.category.id);
  };

  _.each(data.patients, function (p) {
    p.features.cohortIndex = getCohortIndex(p.features.cohortValue, data.config.cohortSelector.cohorts);
  });

  var stateData = {
    data: data,
    updateType: 'cohortSelectionUpdate',
    tweenTime: 250,
    reportUpdate: true
  };

  return stateData;
};

module.exports = statePropsHandler;